const pagination = {
    startPageFunc(current, perPage) {
        return (current - 1) * perPage + 1
    },
    lastPageFunc(current, perPage, total) {
        if (current * perPage < total) {
            return perPage * current
        } else {
            return total
        }
    }
}

export default pagination;